import type { PersonalDataAccessPayload } from '@massilia/contracts'

import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'
import { writeEstimateToken } from './estimate-token.js'

/**
 * Échange le secret du message — ou le nom de famille — contre un jeton d'accès
 * à la demande. Le jeton est gardé pour la session : le client ne revérifie pas
 * à chaque navigation.
 */
export const useGrantEstimateAccessMutation = () =>
  useMutation({
    mutationFn: async ({
      estimateId,
      ...payload
    }: PersonalDataAccessPayload & { estimateId: string }) => {
      const response = await apiClient.client.post<{ accessToken: string }>(
        `/public/estimates/${estimateId}/access`,
        payload
      )

      writeEstimateToken(estimateId, response.data.accessToken)

      return response.data
    },
  })
